module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-hubspot-new/gatsby-browser.js'),
      options: {"plugins":[],"trackingCode":"20280361","respectDNT":true,"productionOnly":false},
    },{
      plugin: require('../node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":800},
    },{
      plugin: require('../node_modules/gatsby-remark-code-buttons/gatsby-browser.js'),
      options: {"plugins":[],"toasterText":"代码复制成功","buttonText":"复制代码"},
    },{
      plugin: require('../node_modules/gatsby-remark-autolink-headers/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-151120017-1"},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Serverless 中文技术社区","short_name":"ServerlessCN","start_url":"/","background_color":"#0052D9","theme_color":"#0052D9","display":"minimal-ui","icon":"src/assets/images/icon-serverless-framework.png"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
